import { ref, watch } from "vue";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import {
  getCurrentDate,
  getStartDate,
  getTokenFromCookies,
} from "@/utils/common";
import { SendUsageHistoryParams } from "@/struct/HistoryStruct";

export function useSettingsDetails(emit: (event: "submit" | "back") => void) {
  const store = useStore();
  const { t } = useI18n();

  const email = ref("");
  const format = ref("PDF");
  const isValid = ref(false);
  const isEmailError = ref(false);
  const isPeriodListShow = ref(false);

  const period = ref({
    title: t("settings.detailsView.periods.threeMonths"),
    key: "three-months",
  });

  const periods = ref([
    {
      title: t("settings.detailsView.periods.week"),
      key: "week",
    },
    {
      title: t("settings.detailsView.periods.month"),
      key: "month",
    },
    {
      title: t("settings.detailsView.periods.threeMonths"),
      key: "three-months",
    },
  ]);

  const changePeriod = (item: { title: string; key: string }) => {
    period.value = item;
    isPeriodListShow.value = false;
  };

  const handleSubmit = () => {
    if (isValid.value) {
      const requestPayload: SendUsageHistoryParams = {
        type: format.value,
        email: email.value,
        start_time: getStartDate(period.value.key),
        end_time: getCurrentDate(),
        token: getTokenFromCookies() ?? undefined,
      };

      store
        .dispatch("history/sendUsageHistory", requestPayload)
        .then((response) => {
          if (response.data.status) emit("submit");
        })
        .catch((error) => {
          console.log("error!", error);
          isValid.value = false;
        });
    }
  };

  const handleEmailFocus = () => {
    isEmailError.value = false;
    isValid.value = false;
  };

  const validateEmail = (emailIsValid: boolean) => {
    isEmailError.value = !!email.value && !emailIsValid;
    isValid.value = !!email.value && emailIsValid;
  };

  const clearData = () => {
    email.value = "";
    emit("back");
  };
  const isSelectPoint = (item: string) => {
    return item === period.value.title;
  };
  watch(email, (newEmail) => {
    if (!newEmail) {
      isValid.value = false;
      isEmailError.value = false;
    }
  });

  return {
    changePeriod,
    clearData,
    email,
    format,
    handleEmailFocus,
    handleSubmit,
    isEmailError,
    isPeriodListShow,
    isValid,
    period,
    periods,
    validateEmail,
    isSelectPoint,
  };
}
